module.exports = {"app.title":"hello world!"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 264
// module chunks = 4